import React from "react";
import Context from "../../../Context";
import visualState from "../../../visualState";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import Scrollpane from "../../Misc/Scrollpane";
import SVGFolder1 from "../../Misc/SvgIcons/SVGFolder1";
import SVGLayout1 from "../../Misc/SvgIcons/SVGLayout1";
import WorkdocFilters from "./WorkdocFilters";
import WorkdocItem from "./WorkdocItem";
import WorkdocList from "./WorkdocList";
import WorkdocStructure from "./WorkdocStructure";
import WorkdocTabs from "./WorkdocTabs";

export default class Workdoc extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.vState = new visualState("WorkdocSection");

    this.state = {
      pending: false,

      customListKey: "",
      listMode: props.listMode,
      structureId: props.structureId,
      itemId: props.itemId,
      urlKey: `${props.listMode}${props.structureId}${props.itemId}`,
      filters: {
        show: false,
        active: [],
        default: [],
      },

      structureItems: null,
      structureItemsSearchDefault: [
        {
          lstr: "(",
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
        {
          field: "typecode",
          compare: "EQL",
          value: "ism.structure",
          rstr: ")",
        },
      ],

      filtersVisible: this.vState.read("filtersVisible", false),
      structureVisible: this.vState.read("structureVisible", false),
      listVisible: this.vState.read("listVisible", true),
      templatesGrid: this.vState.read("templatesGrid", true),
    };
  }
  componentDidMount() {
    this.loadStructure();
    this.load();
    this.renderButtons();
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.listMode !== this.props.listMode ||
      prevProps.itemId !== this.props.itemId ||
      prevProps.structureId !== this.props.structureId
    ) {
      this.setState(
        {
          listMode: this.props.listMode,
          structureId: this.props.structureId,
          itemId: this.props.itemId,
          urlKey: `${this.props.listMode}${this.props.structureId}${this.props.itemId}`,
        },
        () => this.load()
      );
    }
    this.updateSearchParams();
    this.renderButtons();
  }

  loadStructure = async () => {
    this.setState({ pending: true });
    let structureItems = await this.context.api.qoo(
      `/structure/list`,
      { search: this.state.structureItemsSearchDefault },
      undefined,
      undefined,
      undefined,
      "node",
      "sequence"
    );
    this.setState({ pending: false, structureItems });
  };

  load = async () => {
    this.updateSearchParams();
  };

  handleFilters = (changedFilters) => {
    console.log("changedFilters", changedFilters);
    this.setState((state) => {
      let filters = state.filters;
      filters.active = changedFilters;
      return { filters };
    });
  };

  updateSearchParams = () => {
    let searchParams = new URLSearchParams(
      this.props.location.search.substr(1)
    );
    let respond = searchParams.get("respond");
    if (this.state.respond !== respond) {
      this.setState({
        respond,
      });
    }
  };

  onMethodFinish = () => {
    this.setState({ customListKey: this.context.key() });
  };

  toggleVisibleStructure = () => {
    this.setState((state) => {
      this.vState.save({ structureVisible: !state.structureVisible });
      return { structureVisible: !state.structureVisible };
    });
  };

  toggleVisibleFilters = () => {
    this.setState((state) => {
      let filters = state.filters;
      filters.active = [];
      this.vState.save({ filtersVisible: !state.filtersVisible });
      return { filtersVisible: !state.filtersVisible, filters };
    });
  };

  toggleVisibleList = () => {
    this.setState((state) => {
      this.vState.save({ listVisible: !state.listVisible });
      return { listVisible: !state.listVisible };
    });
  };

  renderButtons = () => {
    const filtersActive = false;

    this.context.actionsSet(
      <>
        <button
          title="Отображение фильров"
          onClick={this.toggleVisibleFilters}
          className={`btn btn-icon ${
            this.state.filtersVisible
              ? "bg-light-primary bg-hover-light"
              : "bg-light bg-hover-light-primary"
          }    mr-2`}
        >
          <i
            className={`fa fa-filter  ${
              this.state.filtersVisible && "text-primary"
            }
            ${filtersActive && "text-warning"}
            ${!this.state.filtersVisible && !filtersActive && "text-muted"}
            `}
          ></i>
        </button>
        <button
          title="Отображение списка"
          onClick={this.toggleVisibleList}
          className={`btn btn-icon ${
            this.state.listVisible
              ? "bg-light-primary bg-hover-light"
              : "bg-light bg-hover-light-primary"
          }    mr-2`}
        >
          <span
            className={`svg-icon ${
              this.state.listVisible ? "svg-icon-primary" : "svg-icon-light"
            } `}
          >
            <SVGFolder1 />
          </span>
        </button>
      </>
    );
  };

  render() {
    return (
      <>
        <CrumbsProvider title="Рабочая документация" />

        <div className="row h-100">
          {this.state.filtersVisible ? (
            <div className="col-lg-3 border-right no-print">
              <Scrollpane>
                <Blocker spinnerFixed hAuto on={this.state.pending}>
                  <WorkdocFilters
                    filters={this.state.filters}
                    handleFilters={this.handleFilters}
                  />
                </Blocker>
              </Scrollpane>
            </div>
          ) : null}

          <div
            className={`col-lg-4 no-print border-right ${
              this.state.listVisible ? "" : "d-none"
            }`}
          >
            <Scrollpane>
              <WorkdocTabs
                listMode={this.state.listMode}
                structureId={this.state.structureId}
                itemId={this.state.itemId}
              />
              <WorkdocList
                listMode={this.state.listMode}
                structureId={
                  this.state.structureVisible ? this.state.structureId : "any"
                }
                itemId={this.state.itemId}
                key={this.state.customListKey}
                respond={this.state.respond}
                filters={this.state.filters}
              />
            </Scrollpane>
          </div>
          <div className="col h-100">
            <Scrollpane>
              <WorkdocItem
                listMode={this.state.listMode}
                structureId={this.state.structureId}
                itemId={this.state.itemId}
                onMethodFinish={this.onMethodFinish}
                respond={this.state.respond}
              />
            </Scrollpane>
          </div>
        </div>
      </>
    );
  }
}
